import Logo from "../Logo";

function FooterComponent() {
  return (
    <footer className="site-footer">
      <span className="site-footer__brand">
        <Logo size={14} letters={["G", "D"]} lens="var(--ww-cream)" lensText="var(--ww-ink)" arm="var(--ww-rose)" />
        <span className="site-footer__name">Good Distractions LLC</span>
      </span>
      <ul className="site-footer__links">
        <li><a href="/about">About</a></li>
        <li><a href="/contact">Contact</a></li>
      </ul>
      <span className="site-footer__copy">© 2026</span>
    </footer>
  );
}

export default FooterComponent;
